import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import IconButton from '@mui/material/IconButton';
import { useState, useEffect } from 'react';
import { useInvoiceQuery } from './core/queries';
import Badge from '@mui/material/Badge';
import { useQueryClient } from 'react-query';
import { getIsAuthorized } from './core/AccountProvider'

const reduceInvoices = (invoiceData) => {
  return invoiceData.reduce((acc, invoice) => {
    if (!(invoice.balance === 0)) {
      return ++acc;
    }
    return acc;
  }, 0);
};

const App = () => {
  const { data: invoiceData } = useInvoiceQuery();
  const [value, setValue] = useState(0)
  const queryClient = useQueryClient()

  useEffect(() => {
    if (invoiceData) setValue(reduceInvoices(invoiceData))
    window.PurpleWave?.vent.on('refresh:invoices', () => {
      queryClient.invalidateQueries('invoices')
    });
    window.PurpleWave?.vent.on('logout', () => {
      queryClient.clear()
      setValue(0)
    });
  }, [invoiceData]);




  return (
    <IconButton color="secondary" component="a" href={getIsAuthorized() ? '/account/won' : `/account/login?return=/account/won&feature`} sx={{ fontSize: 'Inherit' }} className='notifications-cart'>
      <Badge variant="dot" color="danger" invisible={value === 0}>
        <ShoppingCartIcon sx={{ fontSize: 'Inherit' }} />
      </Badge>
    </IconButton >
  );
};

export default App;
